module.exports = __webpack_public_path__ + "static/media/princesscamellbanner.d53bbc48.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/princesscamel/princesscamellbanner.png
// module id = 267
// module chunks = 0